<!-- TaskProgressOverlay.vue -->
<template>
  <transition name="fade">
    <div v-if="visible" class="progress-overlay">
      <div class="progress-content">
        <i class="el-icon-loading"></i>
        <p class="progress-percentage">{{ progress.toFixed(0) }}%</p>
        <el-progress
          :percentage="progress"
          :stroke-width="10"
          :show-text="false"
          color="#409EFF"
          class="progress-bar"
        ></el-progress>
        <p class="progress-message">{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "TaskProgressOverlay",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Processing, please wait......",
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}
.progress-content {
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.el-icon-loading {
  font-size: 32px;
  margin-bottom: 15px;
}
.progress-percentage {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 10px 0;
  min-width: 80px;
}
.progress-bar {
  width: 350px;
  margin-bottom: 15px;
}
.progress-message {
  font-size: 16px;
  max-width: 400px;
  line-height: 1.5;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
